import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fixbvxnoxsyolyovqjxm.supabase.co'; // <-- wrap in single or double quotes
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpeGJ2eG5veHN5b2x5b3ZxanhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3OTUwNjgsImV4cCI6MjA2OTM3MTA2OH0.wp43ZIhMOUk5QpNzMvkY2H16ud8MdHR64hJC7NWzQFI'; // <-- wrap in single or double quotes

export const supabase = createClient(supabaseUrl, supabaseAnonKey);